<template>
  <section>
    <header class="header pb-4 pb-md-0">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-5 order-1 pb-3 pb-md-0">
            <img class="img-fluid" src="@/assets/img/peter/peter-1.png" alt="Peter Jordan CyberClass"> 
          </div>

          <div class="col-md-7 text-center text-md-left order-1">
            <h2><strong>#eu</strong>sou<strong>CyberStudent</strong></h2>
            <h3>Agora você faz parte da plataforma que vai encaminhar você para a <strong>conqusita dos seus objetivos.</strong> Pronto para mudar de vida?</h3>
          </div>
        </div>
      </div>
    </header>

    <div class="container mt-5 mb-5">
      <PrimarySectionTitle>
        <div class="text-center">
          <h2 class="text-dark">Próximo passo</h2>
          <h3>Que tal começar com um dos nossos cursos em destaque</h3>
        </div>
      </PrimarySectionTitle>

      <div class="row">
        <div
          v-for="course in coursesHighlight"
          :key="course.id"
          class="col-md-4 col-sm-6 mb-4"
        >
          <CourseThumbBox
            :course="course"
            class="course-thumb-box"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import PrimarySectionTitle from '@/components/layout/PrimarySectionTitle'
  import CourseThumbBox from '@/components/course/CourseThumbBox'

  export default {
    components: {
      PrimarySectionTitle,
      CourseThumbBox,
    },

    metaInfo () {
      return {
        title: '#EuSouCyberStudent | CyberClass'
      }
    },

    async mounted () {
      await this.fetchCoursesHighlight()
    },

    computed: {
      ...mapGetters('course', ['coursesHighlight', 'courseUrl'])
    },

    methods: {
      ...mapActions('course', ['fetchCoursesHighlight'])
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  section {
    background-color: rgba(#000, .012);
  }

  .header {
    box-shadow: 0 5px 15px 2.5px rgba(#000, .09);
    background-color: #fff;
  }

  h2 {
    margin-bottom: 10px;
    color: $highlightPrimaryColor;
    font-weight: 500;
    font-size: 1.75rem;
  }

  h3 {
    font-size: 1.25rem;
    line-height: 1.875rem;
    font-weight: 400;
  }
</style>